function checkImagesLoaded(container = document) {
  const images = container.querySelectorAll('img.track-loaded');

  images.forEach((image) => {
    if (image.complete) {
      image.classList.add('is-complete');
    } else {
      image.addEventListener('load', () => {
        image.classList.add('is-complete');
      });
    }
  });
}

function revealImage(image) {
  image.classList.add('is-revealed');
}

// Opt-in behavior: images with both `track-loaded` and `reveal-on-scroll`
// classes fade/slide in only once they've both finished loading AND
// entered the viewport (rather than revealing as soon as they load).
function initRevealOnScroll(container = document) {
  const images = container.querySelectorAll('img.track-loaded.reveal-on-scroll:not([data-reveal-observed])');

  if (!images.length) return;

  if (!('IntersectionObserver' in window)) {
    images.forEach((image) => {
      image.setAttribute('data-reveal-observed', 'true');
      revealImage(image);
    });
    return;
  }

  images.forEach((image) => {
    image.setAttribute('data-reveal-observed', 'true');

    const reveal = () => {
      if (image.complete) {
        revealImage(image);
      } else {
        image.addEventListener('load', () => revealImage(image), { once: true });
      }
    };

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          reveal();
          obs.unobserve(image);
        }
      });
    }, {
      threshold: 0.1,
    });

    observer.observe(image);
  });
}

checkImagesLoaded();
initRevealOnScroll();

document.addEventListener('shopify:section:load', () => {
  checkImagesLoaded();
  initRevealOnScroll();
});

document.addEventListener('switch:load:images', (e) => {
  const container = e.detail && e.detail.container ? e.detail.container : document;
  checkImagesLoaded(container);
  initRevealOnScroll(container);
});
